import locale from '../../mobile-calendar/locale/en_US'

export default locale



// WEBPACK FOOTER //
// ./src/components/calendar/locale/en_US.js